/**
 * Whether the element that has focus right now got it from the keyboard (`:focus-visible`).
 *
 * @returns false when nothing is focused, or the browser cannot answer the selector
 */
export function hasKeyboardFocus(): boolean {
  if (typeof document === "undefined") return false;

  const active = document.activeElement;
  if (!(active instanceof HTMLElement) || active === document.body) return false;

  try {
    return active.matches(":focus-visible");
  } catch {
    return false;
  }
}
